<div class="wrapper">
    <p class="font-weight-bold" id="title">
        API
    </p>
    <div class="card">
        <div class="card-body">
            <app-table-header
                    [pageIndex]="0"
                    [pageCount]="1"
                    [error]="apikeysService.error"
                    [loading]="apikeysService.loading"
                    [disableFilter]="true"
                    (reload)="apikeysService.loadApiKeys()"
            >
            </app-table-header>
            <ng-container *ngIf="apikeysService.apiKeys != null">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>
                            <p>Shop</p>
                        </th>
                        <th>
                            <p>GET Url für Wordpress</p>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let shop of shops()">
                            <tr>
                                <td>
                                    <p>{{shopDisplay(shop)}}</p>
                                </td>
                                <td>
                                    <a [href]="getApiUrl(shop, apikeysService.apiKeys)">
                                        <p>
                                            {{getApiUrl(shop, apikeysService.apiKeys)}}
                                        </p>
                                    </a>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </div>
</div>
